import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a6e1dfd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2a6e1dfd&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e1dfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6e1dfd')) {
      api.createRecord('2a6e1dfd', component.options)
    } else {
      api.reload('2a6e1dfd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a6e1dfd&scoped=true&", function () {
      api.rerender('2a6e1dfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case/manage/index.vue"
export default component.exports